module.exports = {
	program_of_interest: [
		{
			value: 'Bioengineering',
			label: 'Bioengineering'
		},
		{
			value: 'Chemical and Biomolecular Engineering',
			label: 'Chemical and Biomolecular Engineering'
		},
		{
			value: 'Civil Engineering',
			label: 'Civil Engineering'
		},
		{
			value: 'Computer Science and Engineering',
			label: 'Computer Science and Engineering'
		},
		{
			value: 'Electronic and Computer Engineering',
			label: 'Electronic and Computer Engineering'
		},
		{
			value: 'Environmental Engineering',
			label: 'Environmental Engineering'
		},
		{
			value: 'Industrial Engineering and Decision Analytics',
			label: 'Industrial Engineering and Decision Analytics'
		},
		{
			value: 'Mechanical Engineering',
			label: 'Mechanical Engineering'
		},
		{
			value: 'Others',
			label: 'Others'
		},
		{
			value: 'N/A',
			label: 'N/A'
		}
	],
	salutation: [
		{
			value: 'Prof.',
			label: 'Prof.'
		},
		{
			value: 'Dr.',
			label: 'Dr.'
		},
		{
			value: 'Ms.',
			label: 'Ms.'
		},
		{
			value: 'Mrs.',
			label: 'Mrs.'
		},
		{
			value: 'Mr.',
			label: 'Mr.'
		}
	],
	mode_of_study: [
		{
			value: 'part_time',
			label: 'Part-time'
		},
		{
			value: 'full_time',
			label: 'Full-time'
		}

	],
	year_of_study: [
		{
			value: 'year_1',
			label: 'Year 1'
		},
		{
			value: 'year_2',
			label: 'Year 2'
		},
		{
			value: 'year_3',
			label: 'Year 3'
		},
		{
			value: 'year_4',
			label: 'Year 4'
		},
		{
			value: 'year_5',
			label: 'Year 5'
		},
		{
			value: 'others',
			label: 'Others (Please state)'
		},
		{
			value: 'n/a',
			label: 'N/A'
		}
	],
	gender: [
		{
			value: 'female',
			label: 'Female'
		},
		{
			value: 'male',
			label: 'Male'
		}
	],
	personal_info_gender: [
		{
			value: 'female',
			label: 'Female'
		},
		{
			value: 'male',
			label: 'Male'
		},
		{
			value: 'prefer_not_to_say',
			label: 'Prefer not to say'
		}
	]
};